import { styled } from '@/src/stitches.config'
import HeadlineEyebrow from '@/src/common/components/marketing/headlines/HeadlineEyebrow'
import HelpButtons from '@/src/modules/account/received/HelpButtons'

const ComponentWrapper = styled('div', {
    width: '100%',
    maxWidth: '90vw',
    margin: 'auto',
    py: 30,
    br: 20,
    '.bold': {
        fontWeight: 'bold',
    },
    '.header': {
        fontWeight: 'bold',
        fontSize: '1.35rem',
    },
    variants: {
        padding: {
            default: {
                p: 30,
            },
            onlyY: {
                py: 30,
            },
        },
        backgroundColor: {
            default: {
                backgroundColor: '$white',
            },
            none: {},
        },
        margin: {
            default: {
                mt: 20,
            },
            none: {},
        },
    },
    defaultVariants: {
        backgroundColor: 'default',
        padding: 'default',
        margin: 'default',
    },
})

const ContentWrapper = styled('div', {
    lineHeight: '1.5rem',
    '@media (max-width: 767px)': {
        overflowX: 'scroll',
    },
})

const DetailsWrapper = styled('div', {
    display: 'flex',
    gap: 20,
    '& p': {
        my: 5,
        minWidth: 100,
    },
    '&:last-child': {
        mb: 10,
    },
    '@media (max-width: 767px)': {
        textWrap: 'nowrap',
    },
})

interface IHistoryData {
    date: string
    time: string
    description: string
    isBold?: boolean
}

export interface IHistory {
    history: IHistoryData[] | null
    padding?: 'onlyY' | 'default'
    margin?: 'default' | 'none'
    backgroundColor?: 'default' | 'none'
    showHelpButtons?: boolean
}

const ThreeColumnText = ({
    description,
    date,
    time,
    isBold = false,
}: IHistoryData) => {
    const className = isBold ? 'bold' : ''
    return (
        <DetailsWrapper>
            <p className={className}>{date}</p>
            <p className={className}>{time}</p>
            <p className={className}>{description}</p>
        </DetailsWrapper>
    )
}

const RedemptionHistory = ({
    history,
    padding = 'default',
    backgroundColor = 'default',
    margin = 'default',
    showHelpButtons = false,
}: IHistory) => {
    return (
        <ComponentWrapper
            data-testid={'redemption-history'}
            padding={padding}
            margin={margin}
            backgroundColor={backgroundColor}
        >
            <HeadlineEyebrow
                label={'gift redemption history'}
                style={{ marginBottom: 20 }}
            />
            <ContentWrapper>
                <ThreeColumnText
                    date={'Date'}
                    time={'Time'}
                    description={'Description'}
                    isBold={true}
                />
                {history?.map((item, index) => {
                    const { date, time, description } = item

                    return (
                        <ThreeColumnText
                            key={`history-item-${index}`}
                            date={date}
                            description={description}
                            time={time}
                        />
                    )
                })}
            </ContentWrapper>
            {/*{showHelpButtons && <HelpButtons padding={'onlyY'} />}*/}
        </ComponentWrapper>
    )
}

export default RedemptionHistory
